<template>
    <div class="rate-article">
      <div class="preamble">Was this article helpful?</div>
      <div class="rating">
        <div class="icon -tup" @click="rateThis(true)"></div>
        <div class="icon -tdown" @click="rateThis(false)"></div>
      </div>
      <v-dialog
        v-model="dialog"
        max-width="532"
        :content-class="fromMobile"
        :transition="mobileTransition"
      >
        <v-card class="gratitude-container">
          <v-card-title>
            <div @click="dialog = false" class="icon -close"></div>
          </v-card-title>
          <v-card-text>
            <div class="gratitude">
              <v-img
                class="check"
                src="/img/icons/success.svg"
                contain
                position="center"
                width=70
              ></v-img>
              <h2 class="thanks">Thank you!</h2>
              <p class="message">Your feedback will help us improve our service.</p>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
</template>
<script>
import firebase from 'firebase/app';
import 'firebase/analytics';

export default {
  name: 'RateArticle',
  props: {
    faqArticle: Object,
    articleId: Number,
    mobile: Boolean,
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    fromMobile() {
      return this.mobile ? 'mobile-modal -rating' : '';
    },
    mobileTransition() {
      return this.mobile ? 'dialog-bottom-transition' : 'dialog-transition';
    },
  },
  methods: {
    rateThis(rating) {
      const vote = rating ? 'Positive' : 'Negative';

      firebase.analytics().logEvent('faq_feedback', {
        feedback: vote,
        article: this.faqArticle.title,
      });

      this.dialog = true;
    },
  },
};
</script>
